// local
import PERMISSIONS from 'salvus-shared/lib/permissions';

/**
 * Must check if the user has permission to access this feature.
 *
 * @param {String} feature Key that representes a feature to be tested.
 * @param {Object} account The user that will access the feature.
 */
export default function checkFeatureByUser(featureKey, account) {
    const feature = PERMISSIONS[featureKey];
    // check if the feature exists
    if (feature) {
        // check if the client has access
        // check if the user profile has access
        const profiles = feature[account.client.type];
        if (!profiles || profiles.indexOf(account.profile) === -1) {
            return false;
        } else {
            return true;
        }
    } else {
        // should never happen
        return false;
    }
}
